import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { CustomerService } from 'app/shared/services/customer.service';
import { TranslateService, LangChangeEvent } from '@ngx-translate/core';
import { environment } from 'environments/environment';
import { Router } from '@angular/router';
import { AlertsService } from 'app/shared/services/alerts.service';

const URL = environment.apiUrl + '/invoice';

@Component({
  selector: 'app-upload',
  templateUrl: './upload.component.html',
  styleUrls: ['./upload.component.scss']
})

export class UploadComponent implements OnInit {

  private idToken = 'Bearer ' + localStorage.getItem('id_token');
  private companyId = localStorage.getItem('companyId');
  public customers = [{_id: 'undefined', invoice_email: '', name: this.translate.instant('Select Customer')}];
  private error: any;
  public hasBaseDropZoneOver = false;
  public uploader: FileUploader;
  public invoiceTypes = [{name: this.translate.instant('Invoice'), value: 'Invoice'}, {name: this.translate.instant('Credit Note'), value: 'Credit'}];
  private selectedType = {name: this.translate.instant('Invoice'), value: 'Invoice'};

  constructor(
    private fb: FormBuilder,
    private customerService: CustomerService,
    public translate: TranslateService,
    private router: Router,
    private alertService: AlertsService
    ) {
    this.getCustomers();
    this.uploaderInit();
  }

  ngOnInit() {
    this.uploaderOnAfterAddingFile();
    this.uploaderOnCompleteItem();
    this.translateSelectOnLangChange();
  }

  getCustomers(): void {
    this.customerService.getCustomers().then((res) => {
      for(let customer of res.data)
      {
        this.customers.push(customer);
      }
    }).catch(error => this.error = error);
  }

  onTypeChangeSelect(type) {
    this.selectedType.name = type.name;
    this.selectedType.value = type.value;
  }

  onCustomerChangeSelect(customer, item) {
    if (customer._id) {
      item.selectedValue = true;
      this.uploader.onBuildItemForm = (data, form) => {
        form.append('customer_id', customer._id);
        form.append('customer_name', customer.name);
        form.append('company_id', this.companyId);
        form.append('type', this.selectedType.value);
        form.append('status', 'Processing');
        return { item: data, form }
      };
    } else {
      item.selectedValue = false;
      return;
    }
  }

  translateSelectOnLangChange() {
    this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
      for (let customer of this.customers) {
        if(customer._id == 'undefined') {
           customer.name = this.translate.instant('Select Customer');
        }
      }
      for (let type of this.invoiceTypes) {
        if(type.value == 'Invoice') {
          type.name = this.translate.instant('Invoice');
        } else {
          type.name = this.translate.instant('Credit Note');
        }
      }
    });
  }

  uploaderInit() {
    this.uploader = new FileUploader({
      url: URL,
      isHTML5: true,
      authToken: this.idToken,
      disableMultipart: false,
      itemAlias: 'file',
      allowedFileType: ['pdf'],
      maxFileSize: 5*1024*1024
    });
  }

  uploaderOnCompleteItem() {
    this.uploader.onCompleteItem = (item:any, response:any, status:any, headers:any) => {

      this.alertService.success('Upload-Info')
      .then((event) => {
        if(event.value) {
          this.router.navigate(['/invoices/list']);
        }
      }, function (dismiss) {

      });

    };
  }

  uploaderOnAfterAddingFile() {
    this.uploader.onAfterAddingFile = (item => {
      item.withCredentials = false;
    });
  }

  fileOverBase(e: any): void {
    this.hasBaseDropZoneOver = e;
  }

  upload(item) {
    this.uploader.uploadItem(item);
  }

}



// WEBPACK FOOTER //
// /app/src/app/client/invoices/upload/upload.component.ts